const ApiUrl = `${process.env.VUE_APP_API_PP_CORE}`
import axios from 'src/interceptor-core'

export const requestCoreMixin = {
  methods: {
    getFichaAfiliacion(last = true, id = null, rut = null) {
      const body = {
        last: last,
        id: id
      }

      if (rut !== null) {
        body.cedula = rut
      }

      return axios.post(`${ApiUrl}/afiliacion/ficha`, body);
    },
    getListaAfiliacionAceptada(rut = null) {
      let body = {}
      if (rut !== null) {
        body.cedula = rut
      }
      return axios.post(`${ApiUrl}/afiliacion/lista/aceptadas`, body);
    },
    getFileDocument(filename) {
      return axios({
        url: `${ApiUrl}/documento/${filename}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
  }
};


const getParametros = () => {
  return axios.post(`${ApiUrl}/parametros`)
}

const getMenus = () => {
  return axios.post(`${ApiUrl}/menus`)
}

const getRoles = () => {
  return axios.post(`${ApiUrl}/roles`)
}

const getChartData = (body) => {
  return axios.post(`${ApiUrl}/chart/data`, body)
}

export const configuracionService = {
  getParametros,
  getMenus,
  getRoles,
  getChartData
}
